import React from 'react';
import Layout from '../../shared/components/Layout';
import Main from '../components/Main';

const Stock = () => {
  return (
    <React.Fragment>
      <Layout>
        <Main />
      </Layout>
    </React.Fragment>
  );
};

export default Stock;
